<template>
    <div>
      <section class="content relative">
        <router-view></router-view>
      </section>
    </div>
</template>
<script>
  export default {
    name: 'TariffMergeRouterView'
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/tariffmerge/components/TariffMergeRouterView.vue